import { LoaderFunction, redirect } from "react-router-dom";
import { authService } from "@/services/auth/authService";

export const guestLoader: LoaderFunction = async () => {
  const isAuthenticated = !!authService.getAccessToken(); // coerce a value into a boolean
  if (isAuthenticated) {
    return redirect("/");
  }
  return isAuthenticated;
};
